/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { HealthOfMoms } from './HealthOfMoms';
import {
    HealthOfMomsFromJSON,
    HealthOfMomsFromJSONTyped,
    HealthOfMomsToJSON,
} from './HealthOfMoms';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
} from './PaginationInfo';

/**
 * 
 * @export
 * @interface HealthOfMomPagination
 */
export interface HealthOfMomPagination {
    /**
     * 
     * @type {Array<HealthOfMoms>}
     * @memberof HealthOfMomPagination
     */
    data?: Array<HealthOfMoms>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof HealthOfMomPagination
     */
    meta?: PaginationInfo;
}

/**
 * Check if a given object implements the HealthOfMomPagination interface.
 */
export function instanceOfHealthOfMomPagination(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function HealthOfMomPaginationFromJSON(json: any): HealthOfMomPagination {
    return HealthOfMomPaginationFromJSONTyped(json, false);
}

export function HealthOfMomPaginationFromJSONTyped(json: any, ignoreDiscriminator: boolean): HealthOfMomPagination {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(HealthOfMomsFromJSON)),
        'meta': !exists(json, 'meta') ? undefined : PaginationInfoFromJSON(json['meta']),
    };
}

export function HealthOfMomPaginationToJSON(value?: HealthOfMomPagination | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(HealthOfMomsToJSON)),
        'meta': PaginationInfoToJSON(value.meta),
    };
}

